<app-policy-quote
  (retrieveQuote)="retrieveQuoteService($event)"
  [filteredQuotes]="retrievedQuote"
  [counterValue]="policyDetail.policyValue.insuredAmount"
  [shareList]="policyDetail.intesaFurtherDetails.uni30.quote"
></app-policy-quote>
<hr>
<h5>Dettaglio Garanzie</h5>
<div class="detail-box">
  <div class="detail-item">
    <table aria-label="quote-table" class="table">
      <thead class="bg-light">
        <tr>
          @for (key of garanzieTableKeys; track key.key) {
          <th scope="col">{{ key.label }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (share of policyDetail.intesaFurtherDetails.uni30.garanzie; track
        $index) {
        <tr>
          @for (key of garanzieTableKeys; track key.key) { @if (key.pipe &&
          key.pipe.key === 'currency') {
          <td>{{ (share[key.key] | currency : key.pipe.value) || "N/A" }}</td>
          } @else {
          <td>{{ share[key.key] || "N/A" }}</td>
          } }
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>
<hr>
<h5>Dettaglio Titoli</h5>
<div class="detail-box">
  <div class="detail-item">
    <p class="detail-label">Totale</p>
    <h6>
      {{
        (policyDetail.intesaFurtherDetails.uni30.titoli.total
          | currency : "EUR") || "N/A"
      }}
    </h6>
  </div>
  <div class="detail-item">
    <p class="detail-label">Totale Anno Precedente</p>
    <h6>
      {{
        (policyDetail.intesaFurtherDetails.uni30.titoli.lastYearTotal
          | currency : "EUR") || "N/A"
      }}
    </h6>
  </div>
  <div class="detail-item">
    <p class="detail-label">Totale Anno in corso</p>
    <h6>
      {{
        (policyDetail.intesaFurtherDetails.uni30.titoli.currentYearTotal
          | currency : "EUR") || "N/A"
      }}
    </h6>
  </div>
</div>
<div class="detail-box">
  <div class="detail-item">
    <h6>
      Nota: Per il dettaglio dei pagamenti consultare la sezione "Quietanze e
      Pagamenti" soprastante.
    </h6>
  </div>
</div>
